import { FunctionsHttpError } from '@supabase/supabase-js';
import { supabase } from './supabase.ts';

export class EdgeHiba extends Error {
  constructor(public kod: string, public status: number) { super(kod); }
}

export async function edgeHivas<T>(nev: string, body: unknown): Promise<T> {
  const { data, error } = await supabase.functions.invoke(nev, { body: body as Record<string, unknown> });
  if (!error) return data as T;
  if (error instanceof FunctionsHttpError) {
    const valasz = await error.context.json().catch(() => null) as { hiba?: string } | null;
    throw new EdgeHiba(valasz?.hiba ?? 'szerver', error.context.status);
  }
  throw new EdgeHiba('halozat', 0);
}
